import { css } from "../utils/template-literal-tags";

if (import.meta.env.DEV) {
  const cssDebugStyles = css`
    .css-debug * {
      outline: 1px solid rgba(255, 144, 222, 0.33) !important;
      background-color: rgba(0, 100, 200, 0.1) !important;
    }
  `;

  const styleSheet = document.createElement("style");
  styleSheet.textContent = cssDebugStyles;
  document.head.appendChild(styleSheet);

  document.addEventListener("keydown", (e) => {
    if (e.key === "`") {
      document.body.classList.toggle("css-debug");
    }
  });
}
